module.exports = __webpack_public_path__ + "a98414a06a82d49a4b3418e111ca0a04.pdf";